<template>

<div class="pt-8">
<StoreBreadcrumb :items="breadcrumb" />
            <UPageHeader :title="title" :description="description">
            <template #links>
                <UButton v-if="showBackButton" variant="outline" color="neutral" @click="goBack">
                    <Icon name="i-heroicons-arrow-left" class="w-5 h-5 mr-2" />
                    Back
                </UButton>
                <slot name="links" />
            </template>
                </UPageHeader>

    <UPage :ui="{
        center: 'pt-8 relative'
    }"> 
    
        <template #right>
            <UPageAside>
               <div class="space-y-6">
                <slot name="aside" />
               </div>
            </UPageAside>
        </template>
        <template #default>
            
            <UPageBody>
                <slot />
            </UPageBody>
          
        </template>
    </UPage>
</div>

</template>
<script setup lang="ts">
import type { BreadcrumbItem, ButtonProps } from '@nuxt/ui';
import StoreBreadcrumb from '../organisms/StoreBreadcrumb.vue';

const {
    breadcrumb = [],
    showBackButton = true,
} = defineProps<{
    title?: string;
    description?: string;
    breadcrumb?: BreadcrumbItem[];
    showBackButton?: boolean;
}>();

const router = useRouter();

const goBack = () => {
    if (window.history.length > 1 && router.options.history.state.back) {
        router.back();
    } else if (breadcrumb.length > 1) {
        // Navigate to the second last breadcrumb item if available
        const parentItem = breadcrumb[breadcrumb.length - 2];

        if (parentItem && parentItem.to) {
            router.push(parentItem.to);
        } else {
            router.push('/');
        }
    } else {
        router.push('/');
    }
};
</script>